import React from "react";

import {
    Stack,
    Box,
    Text,
    Flex,
} from "@chakra-ui/react";

import {
    Plus,
    Eye,
    Edit,
    Trash2,
    EllipsisVertical,
} from "lucide-react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";

import ReusableTable from "components/Tables/ReusableTable";

import GradientButton from "components/Buttons/GradientButton";

import ThreeDotMenu from "components/Menus/ThreeDotMenu";

import StatusBadge, {
    getStatusVariant,
} from "../../../../components/Badges/StatusBadge";


const QuestionsDrawer = ({
    isOpen,
    onClose,
    assessment,
    questions,
    loading,
    onAddQuestion,
    onViewQuestion,
    onEditQuestion,
    onDeleteQuestion,
}) => {


 
    // SAFE QUESTIONS
 

    const safeQuestions =
        Array.isArray(questions)
            ? questions
            : Array.isArray(
                questions?.data
            )
                ? questions.data
                : [];


 
    // QUESTION ACTIONS
 

    const generateMenuItems = (
        row
    ) => [

        {
            icon: (
                <Eye
                    size={16}
                />
            ),

            text:
                "View Question",

            onClick: () =>
                onViewQuestion(
                    row.original
                ),
        },


        {
            icon: (
                <Edit
                    size={16}
                />
            ),

            text:
                "Edit Question",

            onClick: () =>
                onEditQuestion(
                    row.original
                ),
        },


        {
            icon: (
                <Trash2
                    size={16}
                />
            ),

            text:
                "Delete Question",

            onClick: () =>
                onDeleteQuestion(
                    row.original
                ),
        },

    ];


 
    // TABLE COLUMNS
 

    const columnsData = [

       
        // QUESTION
       

        {
            Header:
                "QUESTION",

            accessor:
                "question",

            Cell: ({
                value,
            }) => (

                <Text
                    fontWeight="600"
                    noOfLines={2}
                >
                    {
                        value ||
                        "N/A"
                    }
                </Text>

            ),
        },


       
        // CORRECT ANSWER
       

        {
            Header:
                "CORRECT ANSWER",

            accessor:
                "correct_answer",

            Cell: ({
                value,
            }) => (

                <Text
                    fontWeight="600"
                >
                    {
                        value ||
                        "N/A"
                    }
                </Text>

            ),
        },


       
        // DISPLAY ORDER
       

        {
            Header:
                "DISPLAY ORDER",

            accessor:
                "display_order",

            Cell: ({
                value,
            }) => (

                <Text>
                    {
                        value ??
                        "N/A"
                    }
                </Text>

            ),
        },


       
        // STATUS
       

        {
            Header:
                "STATUS",

            accessor:
                "active",

            Cell: ({
                value,
            }) => {

                const status =
                    value
                        ? "Active"
                        : "Inactive";

                return (

                    <StatusBadge

                        label={
                            status
                        }

                        variant={
                            getStatusVariant(
                                status
                            )
                        }

                    />

                );

            },
        },


       
        // ACTIONS
       

        {
            Header:
                "ACTIONS",

            accessor:
                "moreOptions",

            Cell: ({
                row,
            }) => (

                <ThreeDotMenu

                    icon={
                        <EllipsisVertical
                            size={20}
                            color="grey"
                        />
                    }

                    items={
                        generateMenuItems(
                            row
                        )
                    }

                />

            ),
        },

    ];


 
    // RENDER
 

    return (

        <ReusableDrawer

            isOpen={
                isOpen
            }

            onClose={
                onClose
            }


           
            // HEADER
           

            headerContent={

                <Box>

                    <Text
                        fontSize="md"
                        fontWeight="600"
                    >
                        {
                            assessment?.title ||
                            "Assessment"
                        }
                    </Text>

                    <Text
                        fontSize="sm"
                        color="gray.500"
                    >
                        Certification Questions
                    </Text>

                </Box>

            }


           
            // BODY
           

            bodyContent={

                <Stack
                    spacing={5}
                >

                    {/* TABLE HEADER */}

                    <Flex
                        justifyContent="space-between"
                        alignItems="center"
                    >

                        <Text
                            fontSize="md"
                            fontWeight="bold"
                        >
                            All Questions:{" "}
                            {
                                safeQuestions.length
                            }
                        </Text>


                        <GradientButton

                            icon={
                                <Plus
                                    size={16}
                                />
                            }

                            height="40px"

                            onClick={
                                onAddQuestion
                            }

                        >
                            Add Question
                        </GradientButton>

                    </Flex>


                    {/* QUESTIONS TABLE */}

                    <ReusableTable

                        columnsData={
                            columnsData
                        }

                        tableData={
                            safeQuestions
                        }

                        isLoading={
                            loading
                        }

                        emptyMessage={
                            "No questions found for this assessment."
                        }

                    />

                </Stack>

            }

        />

    );
};


export default QuestionsDrawer;